import { Auth0ContextInterface, withAuth0 } from '@auth0/auth0-react';
import classnames from 'classnames';
import React from 'react';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
import useCounter from 'v2/hooks/useCounter';
import { logoutUserAction } from '../../../actions';
import waitlistHeroImage from '../../images/waitlistHeroImage.svg';
import styles from './waitlist.module.scss';

interface WaitlistProps {
  auth0: Auth0ContextInterface;
  // eslint-disable-next-line @typescript-eslint/ban-types
  logoutUserAction: Function;
}

const Waitlist = ({ auth0, logoutUserAction }: WaitlistProps) => {
  const logout = () => {
    logoutUserAction();
    auth0.logout({ returnTo: process.env.REACT_APP_LOGOUT_REDIRECT });
  };
  const counter = useCounter({ from: 15, to: 0, callback: logout });
  return (
    <Container fluid="xl">
      <div
        className={classnames(
          'w-100 d-flex align-items-center mt-5 bg-white shadow',
          'position-relative',
          styles.root
        )}
      >
        <div className={classnames('position-absolute', styles.infoContainer)}>
          <h1>Thank You!</h1>
          <p className={classnames('h4 mt-4', styles.subTitle)}>
            Please check your email for a notification once you have been
            approved for an account.
          </p>
          <p
            className="mt-3 text-light4"
            data-testid={`many_requests_subtitle`}
          >
            We have many requests so this may not be instantaneous. This may
            take up to a day. We appreciate your patience.
          </p>
          <p className="mt-4 mb-5">
            <span className="text-light3">Having trouble?</span>&nbsp;
            <a href="https://www.nomad-data.com/contact">Contact Us.</a>
          </p>
          <a href="http://nomad-data.com" className="mt-3 btn btn-primary">
            Continue to Nomad Homepage
          </a>
          <p className="text-light3 mb-0 mt-3">
            You will be redirected to the login page in {counter} seconds.
          </p>
        </div>

        <img
          className={classnames('img-fluid', styles.heroImage)}
          src={waitlistHeroImage}
          alt="waitlistHeroImage"
        ></img>
      </div>
    </Container>
  );
};

export default connect(null, { logoutUserAction })(withAuth0(Waitlist));
